export default {
  type: 'object',
  properties: {
    selectedSubschool: {
      type: 'string',
      fieldRequired: false
    }
  }
};
